var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditAssignment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 9.00125,
    height: 9.00125,
    viewBox: "0 0 9.00125 9.00125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 7.23125V8.75125C0 8.89125 0.11 9.00125 0.25 9.00125H1.77C1.835 9.00125 1.9 8.97625 1.945 8.92625L7.405 3.47125L5.53 1.59625L0.075 7.05125C0.025 7.10125 0 7.16125 0 7.23125ZM8.855 2.02125C9.05 1.82625 9.05 1.51125 8.855 1.31625L7.685 0.14625C7.49 -0.04875 7.175 -0.04875 6.98 0.14625L6.065 1.06125L7.94 2.93625L8.855 2.02125V2.02125Z",
    fill: "#378EF0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAssignment);
export default __webpack_public_path__ + "static/media/edit-assignment.a34f92bac119a2e0689ddb8904859a5d.svg";
export { ForwardRef as ReactComponent };